import React from 'react';
import withAccordionBox from '@catalogo/service-americanas-common/src/hocs/accordion-box';
import { IInjectedProps } from '@catalogo/service-americanas-common/src/types/accordion-box';
import Title from './components/title';
import ExpandButton from './components/expand-button';
import { IProps } from './types';
import * as Styled from './styles';

export const AccordionBox: React.FC<IProps & IInjectedProps> = ({
  id,
  title,
  htmlElTitle,
  children,
  forwardedRef,
  maxHeightCurrent,
  showExpandButton,
  toggleVisible,
  expandContent,
  isVisible,
}) => (
  <Styled.Container id={id} className="accordion-box">
    <Title toggleVisible={toggleVisible} title={title} isVisible={isVisible as boolean} htmlEl={htmlElTitle} />
    <Styled.ContentWrapper
      ref={forwardedRef}
      style={{ maxHeight: maxHeightCurrent }}
      className="accordion-box-content-wrapper"
    >
      <Styled.Content className="accordion-box-content">{children}</Styled.Content>
    </Styled.ContentWrapper>
    {showExpandButton && <ExpandButton expandContent={expandContent} />}
  </Styled.Container>
);

AccordionBox.defaultProps = {
  htmlElTitle: 'h3',
  anchorRef: '',
};

export default withAccordionBox(AccordionBox);
